
(function () {
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var head = document.getElementById("head");
  var hero = document.getElementById("top");
  var heroCookie = hero.querySelector(".hero-shot img");
  var progressBar = head.querySelector(".head-progress");

  /* ---------- header state and read progress ----------
     Chrome, not motion. This runs even under reduced motion, because a
     transparent bar over a field it has scrolled off would be unreadable. */
  var markImgs = [].slice.call(head.querySelectorAll(".mark img"));
  var journey = document.getElementById("journey");

  function chrome() {
    var headH = head.offsetHeight;
    var solid = hero.getBoundingClientRect().bottom <= headH + 8;
    head.classList.toggle("is-solid", solid);
    var span = document.documentElement.scrollHeight - window.innerHeight;
    var read = span > 0 ? window.scrollY / span : 0;
    progressBar.style.setProperty("--read", Math.min(1, Math.max(0, read)).toFixed(4));

    /* The wordmark opens large and settles to bar size over the first viewport.
       Driven here rather than in scenes(), because it is chrome: it has to keep
       working under reduced motion, where the pins do not run. */
    var cs = getComputedStyle(document.documentElement);
    var lo = parseFloat(cs.getPropertyValue("--mark-min")) || 124;
    var hi = parseFloat(cs.getPropertyValue("--mark-max")) || 248;
    var t = clamp(window.scrollY / (window.innerHeight * 0.55), 0, 1);
    /* ease out, so most of the shrink happens in the first part of the gesture */
    var w = hi + (lo - hi) * (1 - Math.pow(1 - t, 2));
    head.style.setProperty("--mark-w", w.toFixed(1) + "px");
    /* and it rides down as it grows: at full size the mark hangs below the bar
       rather than sitting against its top edge */
    var drop = (w - lo) / (hi - lo || 1) * (headH * 0.34);
    head.style.setProperty("--mark-drop", drop.toFixed(1) + "px");
  }

  /* ---------- depth model ----------
     Signed travel. Positive counters the page scroll and therefore reads as
     distant; negative adds to it and therefore reads as close. Scale and a
     small rotation drift ride along, so depth is carried by three cues at
     once rather than by speed alone. */
  var DEPTH = {
    back:  { range:  150, step:  25, s0: 1.09, s1: 0.95, rot: 3, drift: 0.030 },
    mid:   { range:   45, step:  14, s0: 1.02, s1: 0.99, rot: 2, drift: 0.045 },
    item:  { range:   28, step:   8, s0: 1.00, s1: 1.00, rot: 5, drift: 0.030 },
    slow:  { range:  -60, step: -12, s0: 0.94, s1: 1.08, rot: 3, drift: 0.030 },
    near:  { range: -120, step: -24, s0: 0.95, s1: 1.07, rot: 4, drift: 0.055 },
    front: { range: -190, step: -34, s0: 0.90, s1: 1.12, rot: 7, drift: 0.070 },
    glow:  { range: -160, step: -30, s0: 0.78, s1: 1.26, rot: 9, drift: 0.050 }
  };

  var paintings = [].slice.call(
    document.querySelectorAll(".art img, .card-art img, .paint-item"));
  var counts = { back: 0, mid: 0, item: 0, slow: 0, near: 0, front: 0, glow: 0 };

  paintings.forEach(function (img, i) {
    img.classList.add("paint-float");
    var depth =
      img.classList.contains("glow")      ? "glow"  :
      /* The mascot takes the gentlest travel there is. On the spill layer it
         would otherwise inherit `front` and swing 129px against its section,
         which both reads as a bug and walks it onto the copy. */
      img.classList.contains("bun")       ? "item"  :
      img.classList.contains("paint-item")? "item"  :
      img.classList.contains("slow")      ? "slow"  :
      img.closest(".art--spill")          ? "front" :
      img.closest(".card-art")            ? "near"  :
      img.classList.contains("back")      ? "back"  : "mid";
    var d = DEPTH[depth];
    var n = counts[depth]++;
    img._d = {
      range: d.range + (n % 3) * d.step,
      s0: d.s0, s1: d.s1,
      rot: d.rot * (n % 2 ? 1 : -1),
      drift: d.drift * (i % 2 ? 1 : -1),
      scope: img.closest(".ch") || img.parentElement
    };
  });

  /* group by scope so each chapter's rect is measured once per frame,
     not once per image */
  var scopes = [];
  paintings.forEach(function (img) {
    var s = img._d.scope;
    if (!s._bucket) { s._bucket = { el: s, imgs: [] }; scopes.push(s._bucket); }
    s._bucket.imgs.push(img);
  });

  /* ---------- the two pinned scene types ---------- */
  var stages = [].slice.call(document.querySelectorAll(".ch--stage")).map(function (ch) {
    return {
      ch: ch,
      stage: ch.querySelector(".sticky-stage"),
      move: ch.querySelector(".stage-move"),
      cue: ch.querySelector(".cue"),
      /* the hero must be legible the instant the page paints, so it gets
         no entrance — only the exit drift as the pin releases */
      noEnter: ch.classList.contains("ch--1")
    };
  });

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function scenes() {
    var pinned = window.innerWidth >= 760;
    stages.forEach(function (s) {
      if (!s.move) return;
      if (!pinned) {
        s.move.style.setProperty("--stage-y", "0px");
        s.move.style.setProperty("--stage-o", "1");
        if (s.cue) s.cue.style.setProperty("--cue-o", "1");
        if (s.noEnter && heroCookie) {
          var mobileRect = s.ch.getBoundingClientRect();
          var mobileProgress = clamp(-mobileRect.top / (mobileRect.height || 1), 0, 1);
          heroCookie.style.setProperty("--hero-cookie-rotate", (mobileProgress * 24).toFixed(2) + "deg");
        }
        return;
      }
      var travel = s.ch.offsetHeight - s.stage.offsetHeight;
      var p = travel > 0
        ? clamp(-s.ch.getBoundingClientRect().top / travel, 0, 1)
        : 0;

      var y = 0, o = 1;
      /* The entrance floor is 0.4, not 0. A background tab throttles rAF, so a
         reader who switches away and comes back mid-chapter must still find
         legible copy before the next scroll event repaints it. */
      if (!s.noEnter && p < 0.18) {          // rises into the pin
        var e = p / 0.18;
        y = 44 * (1 - e);
        o = 0.4 + 0.6 * e;
      } else if (p > 0.74) {                  // drifts out as the pin releases
        var x = (p - 0.74) / 0.26;
        y = -46 * x;
        o = 1 - 0.62 * x;
      }
      s.move.style.setProperty("--stage-y", y.toFixed(1) + "px");
      s.move.style.setProperty("--stage-o", o.toFixed(3));
      if (s.cue) s.cue.style.setProperty("--cue-o", clamp(1 - p / 0.22, 0, 1).toFixed(3));
      if (s.noEnter && heroCookie) {
        /* A positive CSS angle turns clockwise. The hero makes one restrained
           24deg turn through its pinned scroll, then holds that finish. */
        heroCookie.style.setProperty("--hero-cookie-rotate", (p * 24).toFixed(2) + "deg");
      }
    });
  }

  /* ---------- the divider ----------
     It is not a pin and not a reel, so it gets its own small travel: the line
     drifts against the scroll while the eyebrow and rule move at different
     rates, which is what stops a one-line section reading as a dead gap. */
  function divider() {
    if (!journey) return;
    var inner = journey.querySelector(".journey-in");
    if (!inner) return;
    var r = journey.getBoundingClientRect();
    var h = window.innerHeight;
    if (r.bottom < -100 || r.top > h + 100) return;
    /* -0.5 at entry, 0 when centred, +0.5 at exit */
    var phase = (h - r.top) / (h + r.height) - 0.5;
    inner.style.setProperty("--jy", (phase * -46).toFixed(1) + "px");
  }

  /* ---------- the reel ----------
     A third scene type: the chapter holds a stage still and the scroll advances
     one item at a time. `.is-reel` is added here, never in CSS, so a script
     failure leaves an ordinary vertical list rather than six stacked items at
     opacity 0. Off below 760px and under reduced motion for the same reason the
     pins are: there is no room, and the effect is the motion. */
  var reels = [].slice.call(document.querySelectorAll(".ch--reel")).map(function (ch) {
    return {
      ch: ch,
      stage: ch.querySelector(".reel-stage"),
      items: [].slice.call(ch.querySelectorAll(".reel-item")),
      rail: [].slice.call(ch.querySelectorAll(".reel-rail i")),
      count: ch.querySelector(".reel-count b"),
      at: -1
    };
  });

  /* Unlike the pins, the reel runs at every width: one item at a time is what a
     phone wants anyway, and the effect is the whole point of the section. */
  function reelOn() { return !reduce; }

  function reelMode() {
    var on = reelOn();
    reels.forEach(function (r) {
      r.ch.classList.toggle("is-reel", on);
      if (!on) {
        r.at = -1;
        r.items.forEach(function (it) { it.classList.remove("is-on", "is-past"); });
        r.rail.forEach(function (i) { i.classList.remove("on"); });
      }
    });
  }

  function reelUpdate() {
    if (!reelOn()) return;

    reels.forEach(function (r) {
      var n = r.items.length;
      if (!n) return;
      var travel = r.ch.offsetHeight - r.stage.offsetHeight;
      var p = travel > 0
        ? clamp(-r.ch.getBoundingClientRect().top / travel, 0, 1)
        : 0;
      /* the last item gets the tail of the scroll rather than a single frame
         at p === 1, so it is readable before the chapter releases */
      var idx = clamp(Math.floor(p * n), 0, n - 1);
      if (idx === r.at) return;
      r.at = idx;
      r.items.forEach(function (it, k) {
        it.classList.toggle("is-on", k === idx);
        it.classList.toggle("is-past", k < idx);
      });
      r.rail.forEach(function (i, k) { i.classList.toggle("on", k === idx); });
      if (r.count) r.count.textContent = (idx + 1 < 10 ? "0" : "") + (idx + 1);
    });
  }

  /* ---------- reveal ----------
     Nothing is hidden in CSS. .pending is added only to what starts below
     the fold, so a script failure, a deep link or a jump scroll can never
     strand content at opacity 0. */
  var pending = [];
  function queueReveal(node, className) {
    if (node.getBoundingClientRect().top > window.innerHeight * 0.92) {
      node.classList.add(className);
      pending.push({ node: node, className: className });
    }
  }

  function reveal() {
    var h = window.innerHeight;
    pending = pending.filter(function (item) {
      if (item.node.getBoundingClientRect().top < h * 0.9) {
        item.node.classList.remove(item.className);
        return false;
      }
      return true;
    });
  }

  /* A 375px column has no margin to move art in: every piece is already
     as far off-canvas as it can go, and any travel walks it onto the copy.
     So the phone gets the composition without the motion — which is also
     the right call for scroll performance on a phone. */
  var travelOff = false;
  function parallax() {
    var h = window.innerHeight;
    if (window.innerWidth < 760) {
      if (!travelOff) {
        travelOff = true;
        paintings.forEach(function (img) {
          img.style.setProperty("--py", "0px");
          img.style.setProperty("--px", "0px");
          img.style.setProperty("--rz", "0deg");
          img.style.setProperty("--sc", "1");
        });
      }
      return;
    }
    travelOff = false;
    for (var i = 0; i < scopes.length; i++) {
      var rect = scopes[i].el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > h + 200) continue;
      var progress = (h - rect.top) / (h + rect.height);
      var phase = progress - 0.5;                 // −0.5 … +0.5
      var t = clamp(progress, 0, 1);
      var imgs = scopes[i].imgs;
      for (var j = 0; j < imgs.length; j++) {
        var img = imgs[j], d = img._d;
        var y = phase * d.range;
        img.style.setProperty("--py", y.toFixed(2) + "px");
        img.style.setProperty("--px", (y * d.drift).toFixed(2) + "px");
        img.style.setProperty("--rz", (phase * 2 * d.rot).toFixed(2) + "deg");
        img.style.setProperty("--sc", (d.s0 + (d.s1 - d.s0) * t).toFixed(3));
      }
    }
  }

  var ticking = false;
  function update() {
    ticking = false;
    chrome();
    if (reduce) return;
    reveal();
    scenes();
    divider();
    reelUpdate();
    parallax();
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  if (!reduce) {
    [].slice.call(document.querySelectorAll(".rise, .art")).forEach(function (node) {
      queueReveal(node, "pending");
    });
    paintings.forEach(function (img) { queueReveal(img, "paint-pending"); });

    // stagger siblings so a chapter resolves as one gesture, not six
    var groups = document.querySelectorAll(
      ".ch-head, .values, .spec, .range, .hero-in, .cta-in, .reel, .bake-notes");
    for (var g = 0; g < groups.length; g++) {
      var kids = groups[g].querySelectorAll(".rise");
      for (var k = 0; k < kids.length; k++) {
        kids[k].style.transitionDelay = (k * 70) + "ms";
      }
    }
  }

  reelMode();
  reelUpdate();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () { reelMode(); onScroll(); }, { passive: true });
  /* run again once images have their real heights, and after a deep link or a
     back/forward restore, so the first paint is never measured against a
     half-laid-out page */
  window.addEventListener("load", onScroll);
  window.addEventListener("pageshow", onScroll);
  window.addEventListener("hashchange", onScroll);
  update();
})();
